<template>
  <v-container fluid class="pa-0">
    <span class="subheading font-weight-bold">
      <slot name="title"></slot>
    </span>
    <span class="grey--text text--darken-3 title">
      <slot name="body"></slot>
    </span>
    <span v-if="link" @click="$router.push(link.to)" class="caption blue--text hover mt-2">
      <v-icon color="blue">mdi-chevron-right</v-icon>
      {{ link.text }}
    </span>
  </v-container>
</template>
<script>
export default {
  props: {
    link: {
      type: Object,
      required: false,
    },
  },
};
</script>
<style scoped>
span {
  display: block;
}
</style>
